// Decision logic for the hair-recolour pass, kept pure so it can be unit-tested
// without a DOM/ONNX runtime.
//
// The recolour reads the ONNX hair mask (`semanticMap.masks.hair`). In
// 'balanced' mode that mask is produced only if the ONNX parser wins a 3.5s
// race against its own warm-up — on a slow device / cold cache (the first
// visitor) it loses, falls back to the MediaPipe-only 'fast' map, and the mask
// is absent. Reusing that map verbatim made picking a hair shade a silent
// no-op. When a shade is chosen and the mask is missing we upgrade to a
// high-quality (ONNX) map on demand so the recolour always has something to
// paint through.

import type { SemanticFaceMap } from '../semantic/semanticFaceMap';
import type { HairShade } from '../catalog/hairShades';

export function needsHairMaskUpgrade(
  shade: HairShade | null | undefined,
  semanticMap: SemanticFaceMap | null | undefined
): boolean {
  return !!shade && !semanticMap?.masks?.hair;
}
